import ReactDOM from 'react-dom/client';
import App from './App';

//rendering the entire application is done here
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
